import React from 'react';
import rootStore from 'Stores/RootStore';

export const storesContext = React.createContext(rootStore);
export const useStores = () => React.useContext(storesContext);
